 import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Routes } from '../enums/route.enum';

@Injectable({
  providedIn: 'root'
})
export class ParametrosService {
  public isCriarNovoBancoDeDados = false;
  private sistema = {
    rotaInicial: Routes.LOGIN,
    isAdm: false,
    isDesabilitarLogin: false,
    isDesabilitarBotaoReiniciarDados: true
  };

  constructor(private restService: RestService) { }

  public criaNovoBancoDeDados(): void {
    const admCredentials = { 
      user: 'adm', 
      password: 'byancacha123' 
    };

    const coupleData = {
      address: 'Rua Das Violetas, 69 - Jd Popular',
      colorPalette: [{cor: '#000000', nome: 'Preto'}, {cor: '#FFFFFF', nome: 'Branco'}],
      dateEvent: '21 de Setembro de 2025',
      hourEvent: '14h',
      noivoName: 'Byanca',
      noivaName: 'Silva'
    }
    this.restService.setAdmUser(admCredentials);
    this.restService.setCoupleData(coupleData);
    this.restService.clonarItens('backup');
  }

  public getSistema() {
    return this.sistema;
  }
}
